import { c as _c } from "react/compiler-runtime";
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum';
import { NotificationsApiInterface } from 'modules/notifications/types/notification-types';
import { useWaitedSharingIdsStorage } from './use-waited-sharing-ids-storage';
export const useAwaitedSharingNotification = () => {
  const $ = _c(4);
  const {
    getItem,
    setItem,
    removeItem
  } = useWaitedSharingIdsStorage();
  let t0;
  if ($[0] !== getItem || $[1] !== removeItem || $[2] !== setItem) {
    const isThereAwaitedSharing = notifications => {
      const waitedSharingIds = getItem();
      if (!waitedSharingIds?.size) {
        return false;
      }
      const gottenSharingIds = notifications?.items?.filter(_temp).map(_temp2);
      const justGottenSharingIds = waitedSharingIds.intersection(new Set(gottenSharingIds));
      const notGottenSharingIds = waitedSharingIds.difference(justGottenSharingIds);
      if (notGottenSharingIds.size) {
        setItem(notGottenSharingIds);
        return true;
      }
      removeItem();
      return false;
    };
    t0 = {
      isThereAwaitedSharing
    };
    $[0] = getItem;
    $[1] = removeItem;
    $[2] = setItem;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp(notification) {
  return notification.eventType === NotificationTypeEnum.SharingStarted;
}
function _temp2(notification_0) {
  return notification_0.data.sharingId;
}